module.exports = __webpack_public_path__ + "static/media/techsphere.4256bb38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/techsphere.svg
// module id = 133
// module chunks = 0